import { createSlice } from "@reduxjs/toolkit";
import {
  initialState,
  handleUpdatePhysicalInventoryNavigationBlocking,
  handleRemovePhysicalInventoryApproverAttachment,
  handleResetPhysicalInventory,
  handleUpdatePhysicalInventoryApproverNotes,
  handleUpdatePhysicalInventoryNotes,
  handleUpdatePhysicalInventoryAdjustment,
  handleUpdatePhysicalInventoryApproverAttachment,
  handleCreatePhysicalInventoryPending,
  handleCreatePhysicalInventoryFulfilled,
  handleCreatePhysicalInventoryRejected,
  handlePhysicalInventoryApproverPending,
  handlePhysicalInventoryApproverFulfilled,
  handlePhysicalInventoryApproverRejected,
  handleCreatePhysicalInventoryIAUPending,
  handleCreatePhysicalInventoryIAUFulfilled,
  handleCreatePhysicalInventoryIAURejected,
  handleEditPhysicalInventoryAdjustment,
  handleFetchPhysicalInventoryDateRejected,
  handleFetchPhysicalInventoryDateFulfilled,
  handleFetchPhysicalInventoryDatePending,
  handleActivateSilentPiDateApiTrigger,
  resetPhysicalInventoryDate
} from "./physicalInventory.reducer";
import {
  createPhysicalInventory,
  createPhysicalInventoryIAU,
  physicalInventoryApprover,
  fetchPhysicalInventoryDate
} from "./physicalInventory.thunk";

const physicalInventorySlice = createSlice({
  name: "physicalInventory",
  initialState,
  reducers: {
    handleUpdatePhysicalInventoryNavigationBlocking,
    handleRemovePhysicalInventoryApproverAttachment,
    handleResetPhysicalInventory,
    handleUpdatePhysicalInventoryApproverNotes,
    handleUpdatePhysicalInventoryNotes,
    handleUpdatePhysicalInventoryAdjustment,
    handleUpdatePhysicalInventoryApproverAttachment,
    handleEditPhysicalInventoryAdjustment,
    handleActivateSilentPiDateApiTrigger,
    resetPhysicalInventoryDate
  },
  extraReducers(builder) {
    builder
      .addCase(
        createPhysicalInventory.pending,
        handleCreatePhysicalInventoryPending
      )
      .addCase(
        createPhysicalInventory.fulfilled,
        handleCreatePhysicalInventoryFulfilled
      )
      .addCase(
        createPhysicalInventory.rejected,
        handleCreatePhysicalInventoryRejected
      )
      .addCase(
        physicalInventoryApprover.pending,
        handlePhysicalInventoryApproverPending
      )
      .addCase(
        physicalInventoryApprover.fulfilled,
        handlePhysicalInventoryApproverFulfilled
      )
      .addCase(
        physicalInventoryApprover.rejected,
        handlePhysicalInventoryApproverRejected
      )
      .addCase(
        createPhysicalInventoryIAU.pending,
        handleCreatePhysicalInventoryIAUPending
      )
      .addCase(
        createPhysicalInventoryIAU.fulfilled,
        handleCreatePhysicalInventoryIAUFulfilled
      )
      .addCase(
        createPhysicalInventoryIAU.rejected,
        handleCreatePhysicalInventoryIAURejected
      )
      .addCase(
        fetchPhysicalInventoryDate.pending,
        handleFetchPhysicalInventoryDatePending
      )
      .addCase(
        fetchPhysicalInventoryDate.fulfilled,
        handleFetchPhysicalInventoryDateFulfilled
      )
      .addCase(
        fetchPhysicalInventoryDate.rejected,
        handleFetchPhysicalInventoryDateRejected
      );
  }
});

export const {
  handleUpdatePhysicalInventoryNotes: updatePhysicalInventoryNotes,
  handleUpdatePhysicalInventoryNavigationBlocking:
    updatePhysicalInventoryNavigationBlocking,
  handleUpdatePhysicalInventoryAdjustment: updatePhysicalInventoryAdjustment,
  handleUpdatePhysicalInventoryApproverNotes:
    updatePhysicalInventoryApproverNotes,
  handleUpdatePhysicalInventoryApproverAttachment:
    updatePhysicalInventoryApproverAttachment,
  handleRemovePhysicalInventoryApproverAttachment:
    removePhysicalInventoryApproverAttachment,
  handleResetPhysicalInventory: resetPhysicalInventory,
  handleEditPhysicalInventoryAdjustment: editPhysicalInventoryAdjustment,
  handleActivateSilentPiDateApiTrigger: activateSilentPiDateApiTrigger,
  resetPhysicalInventoryDate: resetPhysicalInventoryDateData
} = physicalInventorySlice.actions;

export default physicalInventorySlice.reducer;
